/* LNQ · 17-sep-2026 · Carrito: cantidad, quitar y vaciar SIEMPRE contra el carrito vivo.
   Por qué: en esta tienda la "key" de una línea NO es estable. Cualquier cambio que mueva
   el reparto de descuentos (funciones de Bundler o el "Compra 3 y gana 1" nativo) vuelve a
   calcular el hash de TODAS las líneas, no solo de la tocada. Comprobado el 16-sep-2026:
   un único /cart/change.js cambió las tres keys del carrito a la vez.
   El enlace "Quitar" del tema llevaba la key impresa en el href
   (/cart/change?id=<key>&quantity=0). En cuanto el reparto cambiaba, ese href apuntaba a
   una línea que ya no existía y el clic caía en la página de error de Shopify
   "Identificación o parámetro lineal no válidos".
   Aquí no se usa nunca una key guardada en el DOM: antes de cada acción se relee /cart.js
   y se opera por ÍNDICE de línea (o por variante), que es inmune al re-hasheo. Los eventos
   van delegados en document, en fase de captura, para que sobrevivan a cada repintado.
   17-sep-2026 (b) · "Quitar" borra el producto ENTERO de un clic. Comprobado en vivo: cuando
   un mismo variante está partido en varias líneas (la unidad gratis del 4x3 y las particiones
   que deja Shopify al escribir la cantidad a mano: 1 + 1 gratis + 3), /cart/update.js con
   {variante: 0} sólo borra la PRIMERA línea del variante y el renglón sigue en pantalla.
   Ahora, tras ese update, se relee /cart.js y se borran por índice (el más alto primero)
   todas las líneas que queden de ese variante, con o sin propiedades, antes de repintar. */
(function () {
  'use strict';

  var busy = false;

  function routes() {
    var r = (window.theme && window.theme.routes) || {};
    return {
      change: r.cartChange || '/cart/change.js',
      update: '/cart/update.js',
      clear: '/cart/clear.js',
      cart: r.cart || '/cart.js'
    };
  }

  function getCart() {
    return fetch(routes().cart + '?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  function post(url, payload) {
    return fetch(url + '?t=' + Date.now(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  /* ---- identidad de un renglón: variante + propiedades. Nunca la key ---- */

  function rowId(item) {
    var props = item.getAttribute('data-lnq-props');
    if (!props) props = '{}';
    return { variant: String(item.getAttribute('data-lnq-variant') || ''), props: props };
  }

  function sameLine(line, id) {
    if (String(line.variant_id) !== id.variant) return false;
    return JSON.stringify(line.properties || {}) === id.props;
  }

  function linesOf(cart, id) {
    var items = cart.items || [];
    var exact = items.filter(function (l) { return sameLine(l, id); });
    if (exact.length) return exact;
    // respaldo: si las propiedades no cuadran (app que las reescribe), vale el variante
    return items.filter(function (l) { return String(l.variant_id) === id.variant; });
  }

  function indexOfLine(cart, id) {
    var items = cart.items || [];
    for (var i = 0; i < items.length; i++) { if (sameLine(items[i], id)) return i; }
    for (var j = 0; j < items.length; j++) { if (String(items[j].variant_id) === id.variant) return j; }
    return -1;
  }

  // Índice de la ÚLTIMA línea del variante (con o sin propiedades). Se borra de atrás hacia
  // delante para que los índices de las líneas que quedan no se muevan.
  function lastIndexOfVariant(cart, variant) {
    var items = cart.items || [];
    for (var i = items.length - 1; i >= 0; i--) {
      if (String(items[i].variant_id) === variant) return i;
    }
    return -1;
  }

  /* ---- acciones ---- */

  // Quita TODAS las líneas del variante (la pagada, la gratis del 4x3 y cualquier partición),
  // de un solo clic. Paso 1: /cart/update.js {variante: 0}. Paso 2: lo que quede de ese
  // variante se borra por índice releyendo el carrito en cada vuelta.
  function removeRow(id) {
    return getCart().then(function (cart) {
      var lines = linesOf(cart, id);
      if (!lines.length) return cart;
      var updates = {};
      updates[id.variant] = 0;
      return post(routes().update, { updates: updates })
        .catch(function () { return null; })
        .then(function () { return removeRemaining(id.variant, 12); });
    });
  }

  // Borra por índice (el más alto primero) hasta que no quede ninguna línea del variante.
  // Tope de vueltas por seguridad; cada vuelta relee /cart.js.
  function removeRemaining(variant, n) {
    return getCart().then(function (cart) {
      var idx = lastIndexOfVariant(cart, variant);
      if (idx < 0 || n <= 0) return cart;
      return post(routes().change, { line: idx + 1, quantity: 0 }).then(function () {
        return removeRemaining(variant, n - 1);
      });
    });
  }

  // "+" / "-": mueve UNA unidad de la línea pagada; Shopify reparte otra vez la gratis.
  function changeQty(id, delta) {
    return getCart().then(function (cart) {
      var items = cart.items || [];
      var paidIdx = -1, paidQty = 0, i;
      for (i = 0; i < items.length; i++) {
        if (!sameLine(items[i], id)) continue;
        if (items[i].final_line_price === 0) continue;   // la línea gratis no manda
        if (items[i].quantity > paidQty) { paidQty = items[i].quantity; paidIdx = i; }
      }
      if (paidIdx < 0) {
        paidIdx = indexOfLine(cart, id);
        if (paidIdx < 0) return cart;
        paidQty = items[paidIdx].quantity;
      }
      var next = paidQty + delta;
      if (next <= 0) return removeRow(id);
      return post(routes().change, { line: paidIdx + 1, quantity: next });
    });
  }

  function setQty(id, total) {
    if (total <= 0) return removeRow(id);
    return getCart().then(function (cart) {
      var idx = indexOfLine(cart, id);
      if (idx < 0) return cart;
      return post(routes().change, { line: idx + 1, quantity: total });
    });
  }

  function clearCart() {
    return post(routes().clear, {});
  }

  /* ---- repintado: la verdad la tiene el servidor ---- */

  function refresh(cart) {
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
      if (cart) document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    } catch (e) {}

    var form = document.getElementById('CartPageForm');
    if (!form) return Promise.resolve();

    // se deja terminar el repintado propio del tema y luego se sobrescribe con el HTML
    // recién servido, que es el único que trae los importes y los enlaces al día
    return new Promise(function (done) { setTimeout(done, 400); })
      .then(function () {
        return fetch('/cart?t=' + Date.now(), { credentials: 'same-origin' })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var src = doc.getElementById('CartPageForm');
            if (!src) { window.location.reload(); return; }   // carrito vacío: otra plantilla
            ['[data-products]', '[data-subtotal]', '[data-discounts]'].forEach(function (sel) {
              var n = src.querySelector(sel), c = form.querySelector(sel);
              if (n && c) c.innerHTML = n.innerHTML;
            });
            if (window.lazySizes && window.lazySizes.autoSizer) window.lazySizes.autoSizer.checkElems();
          });
      })
      .catch(function () { window.location.reload(); });
  }

  function run(promiseFactory, item) {
    if (busy) return;
    busy = true;
    if (item) item.classList.add('is-loading');
    promiseFactory()
      .then(function (cart) { return refresh(cart); })
      .catch(function () { window.location.reload(); })
      .then(function () { busy = false; });
  }

  /* ---- eventos, delegados en document (captura) ---- */

  document.addEventListener('click', function (evt) {
    var t = evt.target;
    if (!t || !t.closest) return;

    // vaciar el carrito
    var clear = t.closest('[data-lnq-clear], .cart__clear, a[href*="/cart/clear"]');
    if (clear) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      run(function () { return clearCart(); }, null);
      return;
    }

    // quitar un renglón
    var rm = t.closest('.cart__remove a, [data-lnq-remove]');
    if (rm) {
      var itemR = rm.closest('.cart__item');
      if (!itemR) return;
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var idR = rowId(itemR);
      run(function () { return removeRow(idR); }, itemR);
      return;
    }

    // "+" / "-"
    var btn = t.closest('.js-qty__adjust');
    if (btn) {
      var itemQ = btn.closest('.cart__item');
      var wrapper = btn.closest('.js-qty__wrapper');
      if (!itemQ || !wrapper) return;   // ficha de producto: el tema sigue igual
      evt.preventDefault();
      evt.stopImmediatePropagation();
      var input = wrapper.querySelector('.js-qty__num');
      var shown = parseInt(input && input.value, 10);
      if (isNaN(shown)) shown = 1;
      var plus = btn.classList.contains('js-qty__adjust--plus');
      if (input) input.value = plus ? shown + 1 : Math.max(shown - 1, 0);
      var idQ = rowId(itemQ);
      run(function () { return changeQty(idQ, plus ? 1 : -1); }, itemQ);
      return;
    }
  }, true);

  // cantidad escrita a mano: se aplica aquí y se corta el reenvío del formulario
  // que hacen los guiones legados (Booster) con un GET a /cart/change
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input || !input.classList || !input.classList.contains('js-qty__num')) return;
    var item = input.closest ? input.closest('.cart__item') : null;
    if (!item) return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
    var total = parseInt(input.value, 10);
    if (isNaN(total) || total < 0) total = 0;
    var id = rowId(item);
    run(function () { return setQty(id, total); }, item);
  }, true);

  // ningún envío del formulario del carrito salvo el botón de pagar
  document.addEventListener('submit', function (evt) {
    var f = evt.target;
    if (!f || f.id !== 'CartPageForm') return;
    var s = evt.submitter;
    if (s && s.name === 'checkout') return;
    evt.preventDefault();
    evt.stopImmediatePropagation();
  }, true);

  /* ---- el href de respaldo nunca lleva una key ----
     El tema imprime <a href="/cart/change?id=<key>&quantity=0">. Esa key caduca en cuanto
     cambia el reparto de descuentos. Aquí se sustituye por /cart en cuanto aparece en
     pantalla (carga, repintado de la página y reconstruccion del cajon), de modo que si
     algun dia este guion no llegara a engancharse, el peor caso sea recargar el carrito
     y nunca la pagina de error de Shopify. */

  function neutralizeHrefs(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var links = scope.querySelectorAll('.cart__item .cart__remove a[href*="/cart/change"]');
    for (var i = 0; i < links.length; i++) {
      links[i].setAttribute('data-lnq-href-original', links[i].getAttribute('href'));
      links[i].setAttribute('data-lnq-remove', '');
      links[i].setAttribute('href', '/cart');
    }
  }

  function watchCart() {
    neutralizeHrefs(document);
    if (!window.MutationObserver) return;
    var pending = false;
    var obs = new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; neutralizeHrefs(document); }, 60);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchCart);
  } else {
    watchCart();
  }
})();
